import { useState, useEffect } from "react";
import "../../../assets/css/reservation.css";
import { useNavigate } from "react-router-dom";
import { ApiUtil } from "../../../util/apiUtil";
import { Button } from "react-bootstrap";
import { Loading } from "../../../components/loading";
import { ReservationSettingsController } from "../../../controllers/reservationSettingsController";
import { GeneralController } from "../../../controllers/generalController";
import { TableName } from "../../../constants/tableName";
import { AllReservationsList } from "./allReservationsList";
import { TodayReservationsList } from "./todayReservationsList";
import { AvailablePaxList } from "./availablePaxList";
import { Settings } from "./settings";
import { RiSettings4Fill } from "react-icons/ri";
import { MdToday } from "react-icons/md";
import { FaCheckToSlot, FaList } from "react-icons/fa6";

export const ReservationManager = ({ minDate, maxDate }) => {
  const navigate = useNavigate();
  const [user] = useState(() => JSON.parse(localStorage.getItem("user")));
  const [loading, setLoading] = useState(true);
  const [reservationSettings, setReservationSettings] = useState({});
  const [colors] = useState(() => JSON.parse(localStorage.getItem("colors")));
  const [showReservationDescription, setShowReservationDescription] =
    useState(true);
  const [showNormalReservation, setShowNormalReservation] = useState(false);
  const [showEventReservation, setShowEventReservation] = useState(false);
  const [showFunctions, setShowFunctions] = useState(true);
  const [showTodayReservationsList, setShowTodayReservationsList] =
    useState(false);
  const [showAllReservationsList, setShowAllReservationsList] = useState(false);
  const [showAvailablePaxList, setShowAvailablePaxList] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const showDiv = ({
    reservationDescription = true,
    normalReservation = false,
    eventReservation = false,
    todayReservationsList = false,
    allReservationsList = false,
    availablePaxList = false,
    settings = false,
    functions = true,
  }) => {
    setShowReservationDescription(reservationDescription);
    setShowNormalReservation(normalReservation);
    setShowEventReservation(eventReservation);
    setShowTodayReservationsList(todayReservationsList);
    setShowAllReservationsList(allReservationsList);
    setShowAvailablePaxList(availablePaxList);
    setShowSettings(settings);
    setShowFunctions(functions);
  };
  const getExistingCollaborationId = () => {
    new Promise((resolve, reject) => {
      GeneralController.getAll({ resolve: resolve, reject: reject });
    })
      .then((data) => {
        const fetchedData = ApiUtil.deserialize({ data: data });
        if (fetchedData.length > 0) {
          new Promise((resolve, reject) => {
            ReservationSettingsController.getAllViaCollaborationId({
              collaborationId: fetchedData[0].existingCollaboration,
              resolve,
              reject,
            });
          }).then((data) => {
            setReservationSettings(
              ApiUtil.deserialize({
                data: data,
              })[0]
            );
          });
        }
      })
      .catch((error) => console.debug(error))
      .finally(() => setLoading(false));
  };
  const backFunction = () => {
    showEventReservation
      ? showDiv({
          eventReservation: true,
          reservationDescription: false,
        })
      : showDiv({
          normalReservation: true,
          reservationDescription: false,
        });
  };
  useEffect(() => {
    getExistingCollaborationId();
  }, [colors]);
  useEffect(() => {
    if (!user) navigate("/loginSignUp", { state: { isLoginToggle: true } });
  }, [user]);
  useEffect(() => {
    if (minDate && maxDate) {
      setLoading(false);
    }
  }, [minDate, maxDate]);

  return loading ? (
    <Loading />
  ) : (
    <section
      id="reservation"
      style={{
        "--primary-color": colors.primaryColor || "#ffffff",
        "--secondary-color": colors.secondaryColor || "#000000",
        "--tertiary-color": colors.tertiaryColor || "#ffffff",
      }}
    >
      <div className="button-container">
        <Button onClick={() => navigate("/")}>Back To Home Page</Button>
      </div>
      <div className="reservation-container">
        {showReservationDescription && (
          <div>
            <h3>BO RESERVATION</h3>
            <hr />
            <div className="rich-text-preview-div margin-bottom">
              <div
                className="rich-text-preview-inner-div"
                dangerouslySetInnerHTML={{
                  __html: reservationSettings.generalDescription,
                }}
              />
            </div>
          </div>
        )}
        {(showNormalReservation || showEventReservation) && showFunctions && (
          <div>
            <h3>
              {showEventReservation
                ? "BO EVENT RESERVATION"
                : "BO NORMAL RESERVATION"}
            </h3>
            <hr />
            {showEventReservation &&
            reservationSettings?.eventSettings?.externalURL ? (
              <label>
                The external URL is enabled.Please check the event reservation
                records externally.
              </label>
            ) : (
              <div className="grid-button-container">
                <Button
                  onClick={() =>
                    showDiv({
                      reservationDescription: false,
                      todayReservationsList: true,
                      normalReservation: showNormalReservation,
                      eventReservation: showEventReservation,
                      functions: false,
                    })
                  }
                  className="arrow-button"
                >
                  <div className="button-content">
                    <MdToday className="button-icon" />
                    <span>TODAY RESERVATIONS LIST</span>
                  </div>
                </Button>
                <Button
                  onClick={() =>
                    showDiv({
                      reservationDescription: false,
                      allReservationsList: true,
                      normalReservation: showNormalReservation,
                      eventReservation: showEventReservation,
                      functions: false,
                    })
                  }
                  className="arrow-button"
                >
                  <div className="button-content">
                    <FaList className="button-icon" />
                    <span>ALL RESERVATIONS LIST</span>
                  </div>
                </Button>
                <Button
                  onClick={() =>
                    showDiv({
                      reservationDescription: false,
                      availablePaxList: true,
                      normalReservation: showNormalReservation,
                      eventReservation: showEventReservation,
                      functions: false,
                    })
                  }
                  className="arrow-button"
                >
                  <div className="button-content">
                    <FaCheckToSlot className="button-icon" />
                    <span>AVAILABLE PAX LIST</span>
                  </div>
                </Button>
                <Button
                  onClick={() =>
                    showDiv({
                      reservationDescription: false,
                      settings: true,
                      normalReservation: showNormalReservation,
                      eventReservation: showEventReservation,
                      functions: false,
                    })
                  }
                  className="arrow-button"
                >
                  <div className="button-content">
                    <RiSettings4Fill className="button-icon" />
                    <span>SETTINGS</span>
                  </div>
                </Button>
              </div>
            )}
          </div>
        )}
        {showTodayReservationsList && (
          <TodayReservationsList
            isOpen={showTodayReservationsList}
            reservationSettingsId={reservationSettings.id}
            reservationType={
              showEventReservation
                ? TableName.EVENTRESERVATIONS
                : TableName.NORMALRESERVATIONS
            }
            backFunction={backFunction}
          />
        )}
        {showAllReservationsList && (
          <AllReservationsList
            isOpen={showAllReservationsList}
            reservationSettingsId={reservationSettings.id}
            reservationType={
              showEventReservation
                ? TableName.EVENTRESERVATIONS
                : TableName.NORMALRESERVATIONS
            }
            backFunction={backFunction}
            minDate={minDate}
            maxDate={maxDate}
          />
        )}
        {showAvailablePaxList && (
          <AvailablePaxList
            isOpen={showAvailablePaxList}
            reservationSettingsId={reservationSettings.id}
            reservationType={
              showEventReservation
                ? TableName.EVENTRESERVATIONS
                : TableName.NORMALRESERVATIONS
            }
            backFunction={backFunction}
            minDate={minDate}
            maxDate={maxDate}
          />
        )}
        {showSettings && (
          <Settings
            isOpen={showSettings}
            reservationSettingsId={reservationSettings.id}
            reservationType={
              showEventReservation
                ? TableName.EVENTRESERVATIONS
                : TableName.NORMALRESERVATIONS
            }
            backFunction={backFunction}
          />
        )}
      </div>
      {!showTodayReservationsList &&
        !showAllReservationsList &&
        !showAvailablePaxList &&
        !showSettings && (
          <div className="button-container stick-bottom">
            {!showEventReservation && !showNormalReservation && (
              <Button
                onClick={() =>
                  showDiv({
                    reservationDescription: false,
                    normalReservation: true,
                    eventReservation: false,
                  })
                }
                className="arrow-button"
              >
                <span className="arrow">{">"}</span>NORMAL SLOTS
                <span className="arrow">{"<"}</span>
              </Button>
            )}
            {!showEventReservation &&
              !showNormalReservation &&
              reservationSettings?.eventSettings?.timeSlotsList?.length > 0 && (
                <Button
                  onClick={() =>
                    showDiv({
                      reservationDescription: false,
                      normalReservation: false,
                      eventReservation: true,
                    })
                  }
                  className="arrow-button"
                >
                  <span className="arrow">{">"}</span>EVENT SLOTS
                  <span className="arrow">{"<"}</span>
                </Button>
              )}
            {(showNormalReservation || showEventReservation) && (
              <Button
                onClick={() =>
                  showDiv({
                    reservationDescription: true,
                    normalReservation: false,
                    eventReservation: false,
                  })
                }
              >
                BACK
              </Button>
            )}
          </div>
        )}
    </section>
  );
};
